export const datadogApplicationId = process.env.REACT_APP_DATADOG_RUM_APPLICATION_ID;
export const datadogClientToken = process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN;
export const environment = process.env.REACT_APP_ENVIRONMENT;
export const version = process.env.REACT_APP_VERSION;
export const datadogEnabled = datadogApplicationId && datadogClientToken && version;
